<template>
  <b-modal 
    v-model="showModal" 
    ok-only 
    :title="title" 
    ok-variant="hidden"
  >
    <div class="align-center">
      <p v-if="welcome">
        You’re all set! Be on the lookout in your email or text from DashTech to complete your monthly survey <span v-html="surveyDay ? ` on the <b>${ordinalSurveyDay}</b> day of the month.` : '.'" />
      </p>
      <p v-if="survey">
        Complete participation is required for the benefit of your project.
      </p>
      <b-button
        v-if="survey"
        variant="primary"
        :to="surveyUrl"
        @click="hide()"
      >Complete Project Evaluation</b-button>
      <b-button v-else variant="primary" @click="hide()">Close</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    welcome: { type: Boolean, default: false },
    survey: { type: Boolean, default: true },
    surveyDay: { type: String, default: '' },
    projectName: { type: String },
    responseId: { type: String, default: "" },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
  },
  computed: {
    title() {
      return this.welcome
        ? `Welcome to ${this.projectName}`
        : "Complete Project Evaluation";
    },
    surveyUrl() {
      return {
        name: "Survey",
        query: {
          id: this.responseId,
          returnUrl: this.$router.currentRoute.fullPath,
        },
      };
    },
    ordinalSurveyDay() {
      let n = this.surveyDay;

      if (n >= 11 && n <= 13) {
          return `${n}th`;
      }
      switch (n % 10) {
          case 1:  return `${n}st`;
          case 2:  return `${n}nd`;
          case 3:  return `${n}rd`;
          default: return `${n}th`;
      }
    }
  },
};
</script>